export const CALENDAR_SLOT_MINUTES = 30;

/**
 * Empty-slot clicks aim at a clock time, not at the top of a 30-minute cell.
 * A click around 15:20–15:40 is 15:30. The old cell floor turned that into
 * 15:00–15:30. Halfway (15:15, 15:45, …) rounds toward the later time.
 */
export function snappedSlotStartMinutes(
  rawMinutes: number,
  slotMinutes = CALENDAR_SLOT_MINUTES,
): number {
  if (!Number.isFinite(rawMinutes) || slotMinutes <= 0) return 0;
  return Math.round(rawMinutes / slotMinutes) * slotMinutes;
}

export function slotStartMinutesFromOffset(input: {
  offsetY: number;
  hourHeight: number;
  dayStartHour: number;
  dayEndHour: number;
  slotMinutes?: number;
}): number {
  const slotMinutes = input.slotMinutes ?? CALENDAR_SLOT_MINUTES;
  const first = input.dayStartHour * 60;
  const last = Math.max(first, input.dayEndHour * 60 - slotMinutes);
  if (!(input.hourHeight > 0)) return first;
  const raw = first + (input.offsetY / input.hourHeight) * 60;
  const snapped = snappedSlotStartMinutes(raw, slotMinutes);
  return Math.min(last, Math.max(first, snapped));
}
